import { createContext } from 'react'
import { RootStore } from 'state/RootStore'

export const storeContext = createContext(new RootStore())
